export const OPERATOR_PHONE_LIST_CLEAR_STORE = "OPERATOR_PHONE_LIST_CLEAR_STORE";

export const OPERATOR_PHONE_LIST_SUMMURY_LOAD_START = "OPERATOR_PHONE_LIST_SUMMURY_LOAD_START";
export const OPERATOR_PHONE_LIST_SUMMURY_LOAD_SUCCESS = "OPERATOR_PHONE_LIST_SUMMURY_LOAD_SUCCESS";
export const OPERATOR_PHONE_LIST_SUMMURY_LOAD_FAIL = "OPERATOR_PHONE_LIST_SUMMURY_LOAD_FAIL";

export const OPERATOR_PHONE_LIST_LOAD_START = "OPERATOR_PHONE_LIST_LOAD_START";
export const OPERATOR_PHONE_LIST_LOAD_SUCCESS = "OPERATOR_PHONE_LIST_LOAD_SUCCESS";
export const OPERATOR_PHONE_LIST_LOAD_FAIL = "OPERATOR_PHONE_LIST_LOAD_FAIL";

export const OPERATOR_PHONE_LIST_REMOVE_START = "OPERATOR_PHONE_LIST_REMOVE_START";
export const OPERATOR_PHONE_LIST_REMOVE_SUCCESS = "OPERATOR_PHONE_LIST_REMOVE_SUCCESS";
export const OPERATOR_PHONE_LIST_REMOVE_FAIL = "OPERATOR_PHONE_LIST_REMOVE_FAIL";

export const OPERATOR_PHONE_LIST_RESET_TOKEN_START = "OPERATOR_PHONE_LIST_RESET_TOKEN_START";
export const OPERATOR_PHONE_LIST_RESET_TOKEN_SUCCESS = "OPERATOR_PHONE_LIST_RESET_TOKEN_SUCCESS";
export const OPERATOR_PHONE_LIST_RESET_TOKEN_FAIL = "OPERATOR_PHONE_LIST_RESET_TOKEN_FAIL";
